export default __webpack_public_path__ + "media/images/apple-touch-icon-167x167-precomposed-976d4eb8.png";